let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kVX56"), load("02e3i")]).then(() => parcelRequire('5KjQk'));